var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"iframe":"_1wwt5","absolute":"ga_AE","fillAllSpace":"_2F8_x"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._1wwt5 iframe,"+wrap+" iframe._1wwt5{position:relative;display:block;z-index:1}"+wrap+" .ga_AE,"+wrap+" ._2F8_x{width:100%;height:100%}"+wrap+" .ga_AE{position:absolute;top:0;left:0}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

